module.exports = __webpack_public_path__ + "img/icon_today_policy.2cd80a71.png";